import {addItemsToOrder, addItemsToView} from '@explorer/actions/results';

export const buildResultsActions = storedState => {
  const actions = [];
  //backwards compat with old state
  if (storedState.results && storedState.results.selectedItems) {
    actions.push(
      addItemsToView({
        items: storedState.results.selectedItems
          .filter(item => item.on === true)
          .map(item => item.name),
        reset: true,
      })
    );
    actions.push(
      addItemsToOrder({
        items: storedState.results.selectedItems
          .filter(item => item.on === true)
          .map(item => item.name),
        reset: true,
      })
    );
  }

  if (storedState.results && storedState.results.viewItems) {
    actions.push(
      addItemsToView({
        items: storedState.results.viewItems,
        reset: true,
      })
    );
  }

  if (storedState.results && storedState.results.orderItems) {
    actions.push(
      addItemsToOrder({
        items: storedState.results.orderItems,
        reset: true,
      })
    );
  }
  return actions;
};
